/* eslint-disable no-useless-escape */
/* eslint-disable no-new */
/* eslint-disable no-undef */
/* eslint-disable semi */
/* eslint-disable quotes */
/* eslint-disable max-depth */
/* eslint-disable no-magic-numbers */
/* eslint-disable no-invalid-this */
/* eslint-disable no-alert */
/* eslint-disable no-new */

import { MDCSelect } from '@material/select';
import { dimensionEndpoint, projectCreateEndpoint, projectPlacementCreateEndpoint, projectCreativeCreateEndpoint, projectAdgroupCreateEndpoint, projectEmailEndpoint, projectDetailsEndpoint } from './endpoints.js';
import formInit from './form.js';
import showSnackBar from './snackbar';
import styleDropDowns from './styledropdowns.js';
import logger from './util-logger';

export default {
    init: () => {
        const campaign = {
            chooseType: document.querySelector('select#choose_type'),
            typeMedia: document.querySelectorAll('[data-media]'),
            typeSearch: document.querySelectorAll('[data-search]'),
            typeEmail: document.querySelectorAll('[data-email]'),
            generate: document.querySelector('#generate-taxonomy'),
            preview: document.querySelector('.preview-campaign')
        };

        const spacePattern = /\s/g;
        const commaPattern = /,/g;
        const loader = document.querySelector('.mdl-spinner.mdl-loader');

        let filterData;
        let campaignId;
        let placementID;

        const settings = {
            method: 'GET',
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'include',
        }

        function redirectToLogin() {
            localStorage.clear();
            window.location.href = '/';
        }

        function checkSession(json){
            const err = json.errors;
            if (err){
                logger.low(err);
                for ( const [key, value] of Object.entries(err)) {
                    logger.debug('key: ' + key);
                    logger.debug('value: ' + value);
                    key == 'E011' ?  redirectToLogin() : '';
                }
            }
        }

        function loadData(){
            fetch(dimensionEndpoint, settings )
                .then( (response) => { return response.json(); })
                .then( (json) => {
                    loader.classList.add('is-active');
                    checkSession(json);
                    const data = json.data;
                    const dimensions = data.dimensions;
                    populateDropdowns(dimensions);
                }).then( () => {
                    styleDropDowns();
                }).then( () => {
                    loader.classList.remove('is-active');
                }).catch((error) => {
                    logger.crit(error);
                })
        }

        function populateDropdowns(dimensions){
            dimensions.map( (d) => {
                const name = d.name;
                const types = d.type;
                document.querySelectorAll('select').forEach((select) => {
                    const type = select.dataset.name;
                    if ( type == name ) {
                        const compareVals = (a, b) => {
                            return a[1].toString().localeCompare(b[1].toString(), 'en', { numeric: true });
                        };
                        const entries = Object.entries(d.reference_values).sort(compareVals);
                        entries.forEach( (val) => {
                            const val2 = val[1].match(commaPattern) ? val[1].replace(commaPattern, '') : val[1];
                            const option = document.createElement('option');
                            option.setAttribute('data-id', val[0]);
                            option.setAttribute('value', `${val[0]}|${val2}`);
                            option.setAttribute('data-type', types);
                            option.innerText = val[1];
                            select.append(option);
                        });
                    }
                });
            });
        }

        function removeMediaClass(){
            if (document.body.matches('.media-form')){
                document.body.classList.add('media-form');
            }
        }

        function revealTiers(item){
            //refactor this
            if (item == 'media') {
                document.body.classList.add('media-form');
                campaign.typeMedia.forEach((tier) => {
                    if ( tier.hasAttribute('data-media') ) {
                        tier.removeAttribute('hidden');
                    } else {
                        tier.setAttribute('hidden', '');
                    }
                });
                campaign.typeSearch.forEach((tier) => {
                    if ( !tier.hasAttribute('data-media') ) {
                        tier.setAttribute('hidden', '');
                    }
                });
                campaign.typeEmail.forEach((tier) => {
                    if ( !tier.hasAttribute('data-media') ) {
                        tier.setAttribute('hidden', '');
                    }
                });
            }
            if (item == 'search') {
                removeMediaClass();
                campaign.typeSearch.forEach((tier) => {
                    if ( tier.hasAttribute('data-search') ) {
                        tier.removeAttribute('hidden');
                    } else {
                        tier.setAttribute('hidden', '');
                    }
                });
                campaign.typeMedia.forEach((tier) => {
                    if ( !tier.hasAttribute('data-search') ) {
                        tier.setAttribute('hidden', '');
                    }
                });
                campaign.typeEmail.forEach((tier) => {
                    if ( !tier.hasAttribute('data-search') ) {
                        tier.setAttribute('hidden', '');
                    }
                });
            }

            if (item == 'email') {
                removeMediaClass();
                campaign.typeEmail.forEach((tier) => {
                    if ( tier.hasAttribute('data-email') ) {
                        tier.removeAttribute('hidden');
                    } else {
                        tier.setAttribute('hidden', '');
                    }
                });
                campaign.typeMedia.forEach((tier) => {
                    if ( !tier.hasAttribute('data-email') ) {
                        tier.setAttribute('hidden', '');
                    }
                });
                campaign.typeSearch.forEach((tier) => {
                    if ( !tier.hasAttribute('data-email') ) {
                        tier.setAttribute('hidden', '');
                    }
                });
            }
        }

        function formatDate(date) {
            const inputDate = new Date(date);
            return inputDate.toLocaleDateString('en-US', { timeZone: 'UTC', year: 'numeric', month: '2-digit', day: '2-digit' });
        }

        

        //populates data in the preview campaign table
        function processOutcome(form, e) {
            const ids = e.target.id;
            const field = form.querySelector(`#${e.target.id}`);
            document.querySelectorAll(`.preview-campaign:not([hidden]) table span.${ids}`).forEach((item) => {
                const itemParent = item.parentElement == document.querySelector('.preview-campaign:not([hidden]) .finalUrl');

                function filterChannel() {
                    const fieldValue = field.value;
                    if (fieldValue.match(/SEO/g)) {
                        item.innerText = 'organic';
                    } else if ( fieldValue.match(/HCP Rep Email|CRM Email|3rd Party Email/g) ) {
                        item.innerText = 'email';
                    } else if ( fieldValue.match(/Patient Advocacy Partners|Media Partnership/g) ) {
                        item.innerText = 'referral';
                    } else if ( fieldValue.match(/Paid Search/g)) {
                        item.innerText = 'sem';
                    } else if (fieldValue.match(/Digital Audio|Digital OOH|Point of Care|Digital Print|SMS/g)) {
                        item.innerText = 'cpv';
                    } else if (fieldValue.match(/Broadcast|Radio|Out Of Home|TeleHealth|Print|Direct Mail|Addressable TV|Tele Sales/g)) {
                        item.innerText = 'offline';
                    } else if ( fieldValue.match(/OLV/g)) {
                        item.innerText = 'olv';
                    } else {
                        item.innerText = 'display';
                    }
                }

                if ( item && itemParent ) {
                    //quick fix
                    if (field.dataset.name == 'website_url') {
                        item.innerText = field.value;
                    } else if (field.type == 'text') {
                        item.innerText = field.value.replace(/\s/g, '%20');
                    } else if (field.dataset.name == 'Channel' && item.matches('.ga_channel')) {
                        filterChannel();
                    } else {
                        item.innerText = field.value.split('|')[1].replace(spacePattern, '%20');
                    }
                    item.removeAttribute('hidden');
                } else if (item){
                    if (field.type == 'text' && field.dataset.name.match('Additional')) {
                        item.innerText = field.value;
                    }else if ( field.type == 'text' ) {
                        item.innerText = field.value + '|';
                    } else if (field.type == 'date'){
                        item.innerText = formatDate(field.value);
                    } else {
                        item.innerText = field.value.split('|')[1] + '|';
                    }
                    item.removeAttribute('hidden');
                }
            });
        }

        function formatAllOutcomes(form, step){
            const getAllPermutationsCount = (arr) => {
                // Takes in an array of arrays i.e. [ [], [], [], []]
                // Returns a permutation count
                return arr.reduce( (acc, i) => { return acc * i[0]; }, 1);
            }
            const formObject = {};
            Array.from(step.querySelectorAll('input[type="text"]:not([data-name="website_url"]),select,input[type="number"],input[type="date"]')).filter((elem) => { return elem.dataset.name }).forEach((elem) => {
                if (elem.options) {
                    const selected = [...elem.selectedOptions].map((opt) => { return opt.value.split('|')[1] });
                    formObject[elem.dataset.name] = selected;
                } else if(elem.type == 'date') {
                    formObject[elem.dataset.name] = formatDate(elem.value);
                } else if (elem.type == 'text' && elem.name == 'searchGroupName__searchDetail' ){
                    formObject[elem.dataset.name] = elem.value;
                } else {
                    formObject[elem.dataset.name] = elem.value.replace(commaPattern, '');
                }
            });

            const newFormValue = new URLSearchParams(formObject).toString();

            const res = newFormValue.split('&').map((item) => {
                return [item.split('=')[0], item.split('=')[1].match(/\%7C/g) ? item.split('%7C')[1] : item.split('=')[1].split('%2C')]
            }).filter((word) => { return word.length > 1 }).reduce((acc, item) => {
                if ( acc.keys.indexOf(item[0]) === -1) {
                    acc.keys.push(item[0]);
                    acc.output.push(item);
                }

                const checkIfOne = acc.count.filter((i) => { return i.key === item[0] });

                if ( acc.count.length === 0 || checkIfOne.length === 0 ) {
                    acc.count.push({ key: item[0], values: item[1] })
                } else {
                    acc.count.map( (i) => {
                        i.key === item[0] && item[1] !== '' ? i.values.push(item[1]) : '';
                        return i;
                    });
                }

                return { output: acc.output, keys: acc.keys, count: acc.count };
            }, { output: [], keys: [], count: [] })

            const permutationsCount = getAllPermutationsCount( res.count.map((i) => { return [i.values.length] }) );

            outputResults(permutationsCount)
        }

        function outputResults(total) {
            const footer = document.querySelector('.preview-campaign:not([hidden]) table > tfoot');
            footer.innerHTML = `
             <tr>
             <td>Output Results: ${total != 0 ? total : ''}</td>
             </tr> `;
        }

        function getValuesForCampaigns(form) {
            let noEmpty = false;
            const cForm = form.querySelectorAll('select.field_select,input[type="text"],input[type="date"]');
            const steps = form.querySelectorAll('.inputAndSelect:not([hidden])');
            steps.forEach( (step) => {
                [...cForm].forEach( (ele) => {
                    ele.addEventListener('change', (e) => {
                        ele.value != '' ?  noEmpty = true : noEmpty = false;
                        noEmpty == true ? processOutcome(form, e) : '';
                        formInit.init();
                        formatAllOutcomes(form, step);
                    });
                    if ( ele.type != 'select') {
                        ele.addEventListener('input', () => {
                            formInit.init();
                        })
                    }
                });
            });
            return noEmpty;
        }

        // clear multiselect clear function I got from stackoverflow
        function resetSelectElement(selectElement) {
            const options = selectElement.options;
            // Look for a default selected option
            for (let i = 0, iLen = options.length; i < iLen; i++) {
                if (options[i].defaultSelected) {
                    selectElement.selectedIndex = i;
                    return;
                }
            }
            // If no option is the default, select first or none as appropriate
            selectElement.selectedIndex = 0; // or -1 for no option selected
        }

        function clearFields(step, form){
            const section = document.querySelector(step);
            section.classList.add('cleared');
            const fields = section.querySelectorAll('select, input[type="text"], input[type="date"], input[type="number"]');
            if ( section.matches('.cleared')) {
                logger.debug(fields);
                fields.forEach((field) => {
                    if ( field.type == 'select'){
                        field.clearOptions();
                        logger.debug(field.parentElement);
                        field.parentElement.querySelector('label.floating-label.active').classList.remove('active');
                        field.parentElement.querySelector('.mdl-textfield__error.active').classList.remove('active');
                        resetSelectElement(field);
                    } else if ( field.type == 'text' || field.type == 'date' || field.type == 'number' ) {
                        field.value = '';
                        field.parentElement.classList.remove('is-dirty');
                    }
                });
                section.querySelectorAll('.ts-wrapper .item a').forEach( (opt) => {
                    const parentEl = opt.parentElement.parentElement.parentElement.parentElement;
                    opt.click();
                    parentEl.querySelector('label.floating-label.active') ?  parentEl.querySelector('label.floating-label.active').classList.remove('active') : '';
                    parentEl.querySelector('.mdl-textfield__error.active') ? parentEl.querySelector('.mdl-textfield__error.active').classList.remove('active') : '';
                });
                form.scrollIntoView({ behavior: 'smooth' } );
            }
        }

        function validateFields(form, step){
            let noError = true;
            const section = form.querySelector(step);
            const fields = section.querySelectorAll('select[required], input[type="text"][data-required]');
            fields.forEach((field) => {
                if (!field.value){
                    form.querySelector('.form-err-msg').classList.add('active');
                    noError = false;
                } else if (field.value) {
                    form.querySelector('.form-err-msg').classList.remove('active');
                    if (form.querySelectorAll('.mdl-textfield__error.active').length == 0 ) {
                        form.querySelector('.form-err-msg').classList.remove('active');
                        noError = true;
                    }
                }
            });
            return noError;
        }

        function onSuccess(form, step, nextStep, message) {
            showSnackBar.showMessage(message);
            logger.debug(nextStep);
            if ( nextStep ){
                form.querySelector(step).setAttribute('hidden', '');
                form.querySelector(nextStep).removeAttribute('hidden');
            } else {
                form.querySelector(step).removeAttribute('hidden');
            }
            if ( form.querySelector('.err-container:not(hidden)')) {
                form.querySelector('.err-container').setAttribute('hidden', '');
            }

            if ( document.body.matches('media-creative-step')){
                document.querySelector('div#mediaStepTwo').setAttribute('hidden', '');
                document.querySelector('div#mediaStepThree').removeAttribute('hidden');
            }
        }

        function redirectToCampaign(id) {
            const num = 5500;
            setTimeout( () => {
                window.location.href = `/campaign?id=${id}`;
            }, num)
        }

        function failFetch(form) {
            const errorContainer = form.querySelector('.err-container');
            errorContainer.removeAttribute('hidden');
        }

        function failFormError(form, data){
            const msg = data;
            const err = msg.errors;
            logger.high(err);
            for ( const [key, value] of Object.entries(err)) {
                logger.debug('key: ' + key);
                logger.debug('value: ' + value);
                if ( key == 'E030') {
                    form.querySelector('.err-container').removeAttribute('hidden');
                    form.querySelector('.err-container strong').innerText = 'This item already exists';
                } else {
                    form.querySelector('.err-container').removeAttribute('hidden');
                    form.querySelector('.err-container strong').innerText = 'Error occured';
                }
                form.querySelector('.err-container').scrollIntoView({ behavior: 'smooth' });
            }
        }

        function createCampaign(data, form, endpoint, step, nextStep, message){
            const fetchSettings = {
                method: 'POST',
                body: JSON.stringify(data),
                mode: 'cors',
                credentials: 'include',
                headers: new Headers({
                    'Content-Type': 'application/json'
                })
            };
            loader.classList.add('is-active');
            fetch(endpoint, fetchSettings)
                .then((response) => { return response.json(); })
                .then( (data) => {
                    logger.debug(data);
                    loader.classList.remove('is-active');
                    if (data.success === true) {
                        onSuccess(form, step, nextStep, message);
                        const campaignID = Object.values(data.data);
                        campaignId = campaignID.toString();
                        return campaignID;
                    } else if (data.success === false) {
                        failFormError(form, data);
                        return false;
                    }
                }).then( (result) => {
                    logger.info('campain id', result);
                }).catch((error) => {
                    failFetch(form, error);
                });
            return campaignId;
        }

        function getCampaignData (url, step) {
            const loader = document.querySelector('.mdl-spinner.mdl-loader');
            loader.classList.add('is-active');
            const settings = {
                method: 'GET',
                mode: 'cors',
                credentials: 'include',
            };
            const onFail = (error) => {
                logger.crit(error);
            };
            const getdata = new Promise( (resolve) => {
                fetch( dimensionEndpoint, settings)
                    .then( (response) => { return response.json(); })
                    .then( (json) => {
                        filterData = json.data;
                        resolve();
                        return filterData;
                    });
            });
            getdata.then( () => {
                fetch(url, settings)
                    .then( (response) => { return response.json(); })
                    .then( (json) => {
                        loader.classList.remove('is-active');
                        const data = json.data;
                        logger.debug(data);
                        placementsListedOnCreativeForm(data);
                        step.querySelector('.placements-selected').removeAttribute('hidden');
                    }).catch((error) => { return onFail(error); } );
            })
        }

        function createCampaignItems(data, form, endpoint, step, nextStep, message){
            const fetchSettings = {
                method: 'POST',
                body: JSON.stringify(data),
                mode: 'cors',
                credentials: 'include',
                headers: new Headers({
                    'Content-Type': 'application/json'
                })
            };
            loader.classList.add('is-active');
            fetch(endpoint, fetchSettings)
                .then((response) => { return response.json(); })
                .then( (data) => {
                    loader.classList.remove('is-active');
                    if (data.success === true) {
                        const response = data.data;
                        onSuccess(form, step, nextStep, message);
                        if (document.body.matches('.media-form')){
                            logger.debug(response);
                            placementID = response.id ? response.id : '';
                            return placementID;
                        }
                        if ( document.body.matches('.media-creative-step')) {
                            const campaignID = Object.values(data.data);
                            campaignId = campaignID.toString();
                            return campaignID;
                        }
                    } else if (data.success === false) {
                        failFormError(form, data);
                        return false;
                    }
                    return data;
                }).then( (result) => {
                    if ( document.body.matches('.media-form') && !document.body.matches('.media-creative-step')) {
                        logger.debug(result.id);
                        getCampaignData(projectDetailsEndpoint + '?id=' + campaignId, document.querySelector('#mediaStepThree'));
                        document.body.classList.add('media-creative-step');
                    }
                    if ( !document.body.matches('.media-form')){
                        redirectToCampaign(campaignId);
                    } else if (document.body.matches('.media-form-done') ){
                        redirectToCampaign(campaignId);
                    }
                }).catch((error) => {
                    failFetch(form, error);
                });
            if (document.body.matches('.media-form')){
                return placementID;
            }
        }

        function createCampaignItemsAndClear(data, form, endpoint, step, nextStep, message){
            const fetchSettings = {
                method: 'POST',
                body: JSON.stringify(data),
                mode: 'cors',
                credentials: 'include',
                headers: new Headers({
                    'Content-Type': 'application/json'
                })
            };
            loader.classList.add('is-active');
            fetch(endpoint, fetchSettings)
                .then((response) => { return response.json(); })
                .then( (data) => {
                    loader.classList.remove('is-active');
                    if (data.success === true) {
                        const response = data.data;
                        onSuccess(form, step, nextStep, message);
                        if ( document.body.matches('.media-creative-step')) {
                            const campaignID = Object.values(response);
                            campaignId = campaignID.toString();
                            return campaignID;
                        }
                    } else if (data.success === false) {
                        failFormError(form, data);
                        return false;
                    }
                }).then(() => {
                    clearFields(step, form);
                }).catch((error) => {
                    failFetch(form, error);
                });
            if (document.body.matches('.media-form')){
                return placementID;
            }
        }

        function filterRefs(dim, ref) {
            if ( ref ) {
                return ref.length > 1 ? ref.map( (item) => { return filterList(dim, item); } ) : filterList(dim, ref);
            }
        }

        //populates placements on the add creatvies form
        function placementsListedOnCreativeForm(data){
            data.placements.map( (d) => {
                document.querySelectorAll('select#placementIds').forEach((select) => {
                    const newFormValue = new URLSearchParams(d.dimensions).toString();
                    const res = newFormValue.split('&').map((item) => {
                        return [item.split('=')[0], item.split('=')[1].split('%2C')];
                    }).filter((word) => { return word.length > 1; }).reduce((acc, item) => {
                        if ( acc.keys.indexOf(item[0]) === -1) {
                            acc.keys.push(item[0]);
                            acc.output.push(item);
                        }
                        return { output: acc.output, keys: acc.keys };
                    }, { output: [], keys: [] });
                    const joinedString = res.output.map( (i) => {
                        const filterRefVal = filterRefs(i[0], i[1]);
                        return  !filterRefVal || ( Array.isArray(filterRefVal) && filterRefVal.filter( x => x).length == 0 ) ? i[1].toString().replace(/\++/g, ' ' ) : filterRefVal;
                    }).join('|');
                    const option = document.createElement('option');
                    option.setAttribute('data-id', d.id);
                    option.setAttribute('value', `${d.id}`);
                    option.innerText = joinedString;
                    select.append(option);
                });
            });
            stylePlacements();
        }

        function stylePlacements(){
            const campaignSelects = document.querySelectorAll('.placements-selected .creative-multi-select select#placementIds');
            campaignSelects.forEach( (select) => {
                new TomSelect(select, {
                    plugins: ['remove_button'],
                    onDropdownOpen: function(dropdown) {
                        dropdown.parentElement.parentElement.querySelector('label.floating-label').classList.add('active');
                    },
                    onDropdownClose: function(dropdown) {
                        if ( dropdown.querySelectorAll('.selected').length == 0){
                            dropdown.parentElement.parentElement.querySelector('label.floating-label').classList.add('active');
                        }
                    },
                    onBlur: function(){
                        if ( this.wrapper.querySelectorAll('.selected').length == 0){
                            this.wrapper.parentElement.querySelector('label.floating-label').classList.add('active');
                        }
                    },
                    onChange: function(){
                        this.wrapper.classList.toggle('is-invalid', !this.isValid);
                    },
                });
            });
        }

        function filterList(dimensionName, referenceName){
            const dims = filterData.dimensions;
            const refValues = dims.filter( (dim) => {
                if ( dim.type == 'Lookup'){
                    return dim.reference_values;
                }
            });
            const dimensionValues = dims.map( (dim) => {
                return dim.id  == dimensionName ? dim.name : '';
            });

            const dimensionValue = dimensionValues.join('').toString();
            const refVal = refValues.map( (refValue) => {
                for ( const [key, value] of Object.entries(refValue.reference_values)){
                    if ( key == referenceName && key ) {
                        const val = value.split(',');
                        return [...val];
                    }
                }
            });
            const ref_val = refVal.join('').toString();
            return ref_val;
        }

        function getFormValues(form, formStep){
            const user = localStorage.getItem('data.userSession.csrfToken');
            const fType = form.dataset.type;
            const token = { 'csrfToken': user };
            const formType = { 'type': fType };
            const campId = { 'campaignId': campaignId };
            const placements = [...document.querySelector('select#placementIds').selectedOptions].map((opt) => { return opt.value; });
            const placementIdCreatives = { 'placementIds': placementIds };
            const placementIds = { 'placementIds': placements };
            const url = form.querySelector('input[data-name="website_url"]') ? form.querySelector('input[data-name="website_url"]').value : '';
            const websiteUrl = { 'website_url': url };
            const formObject = {};
            Array.from(document.querySelector(formStep).querySelectorAll('input[type="text"]:not([data-name="website_url"]),select:not(#placementIds),input[type="number"],input[type="date"]')).filter((elem) => { return elem.dataset.name }).forEach((elem) => {
                if ( elem.value != '' ) {
                    if (elem.options) {
                        const selected = [...elem.selectedOptions].map((opt) => { return opt.value.split('|')[0] });
                        formObject[elem.dataset.name] = selected;
                    } else if (elem.type == 'date'){
                        formObject[elem.dataset.name] = formatDate(elem.value);
                        if ( !elem.value ){
                            formObject[elem.dataset.name] = null;
                        }
                    } else if (elem.type == 'number') {
                        formObject[elem.dataset.name] = parseInt(elem.value);
                        if ( !elem.value ){
                            formObject[elem.dataset.name] = null;
                        }
                    } else {
                        formObject[elem.dataset.name] = elem.value;
                    }
                }
            });
            const dimensions = { 'dimensions': formObject };
            const wholeObj = {};

            document.querySelector(formStep).matches('.campaign-name') || document.querySelector(formStep).matches('.search-campaign-name') || document.querySelector(formStep).matches('.campaign-name-email') ? Object.assign(wholeObj, formType) : '';

            document.querySelector(formStep).matches('.placement-name') || document.querySelector(formStep).matches('.email-name') ? Object.assign(wholeObj, campId) : '';

            if ( document.querySelector(formStep).matches('.search-group-name')) {
                Object.assign(wholeObj, campId);
                if ( form.querySelector('input[data-name="website_url"]') ){
                    form.querySelector('input[data-name="website_url"]').value != '' ? Object.assign(wholeObj, websiteUrl) : '';
                }
            }

            if ( document.querySelector(formStep).matches('.creative-name') ) {
                Object.assign(wholeObj, placementIds);
                url != '' ? Object.assign(wholeObj, websiteUrl) : '';
            }

            if ( form.querySelector('input[data-name="website_url"]').value != ''){
                Object.assign(wholeObj, websiteUrl);
            }

            Object.assign(wholeObj, token);
            Object.assign(wholeObj, dimensions);
            logger.debug(wholeObj);
            return wholeObj;
        }

        function generateNames(step, nextStep, form, message){
            if (validateFields(form, step)) {
                createCampaign(getFormValues(form, step), form, projectCreateEndpoint, step, nextStep, message);
            } else {
                return false
            }
        }

        function generateCampaignItems(step, nextStep, form, endpoint, message){
            if (validateFields(form, step)) {
                createCampaignItems(getFormValues(form, step), form, endpoint, step, nextStep, message);
            } else {
                return false
            }
        }

        function generateCampainItemAndClear(step, nextStep, form, endpoint, message){
            if (validateFields(form, step)) {
                createCampaignItemsAndClear(getFormValues(form, step), form, endpoint, step, nextStep, message);
            } else {
                return false;
            }
        }

        function checks() {
            if (document.querySelector('.preview-campaign') ){
                const spans = document.querySelectorAll('.preview-campaign span');
                spans.forEach((span) => {
                    span.innerText == '' ? span.setAttribute('hidden', '') : span.removeAttribute('hidden')
                })
            }
        }

        if ( document.querySelector('.newCampaign') ){
            loadData();
            checks();
            const executeTiers = new Promise((resolve) => {
                if ( document.querySelector('#choose-mdc-select') ) {
                    const select = new MDCSelect(document.querySelector('#choose-mdc-select'));
                    select.listen('MDCSelect:change', () => {
                        revealTiers(select.value);

                        setTimeout( () => {
                            resolve();
                            document.querySelector('#choose-mdc-select .mdc-select__anchor').classList.add('mdc-select--disabled');
                            document.querySelector('#choose-mdc-select .mdc-select__anchor').setAttribute('disabled', true);
                            document.querySelector('#choose-mdc-select .mdc-select__dropdown-icon').setAttribute('hidden', true);
                        }, 500);
                    });
                }
            });
            executeTiers.then( () => {
                const chosenForm = document.querySelector('form.add-new-campaign:not([hidden])');
                const createBtn = chosenForm.querySelector('.btn-create-campaign');
                const placementBtn = chosenForm.querySelector('.btn-create-placement');
                const placementAddBtn = chosenForm.querySelector('.btn-add-placement');
                const creativeBtn = chosenForm.querySelector('.btn-create-creatives');
                const creativeAddBtn = chosenForm.querySelector('.btn-create-add-creatives');
                const searchBtn = chosenForm.querySelector('.btn-create-add-group');
                const searchGroupBtn = chosenForm.querySelector('.btn-create-add-ad-group');
                const emailNameBtn = chosenForm.querySelector('.btn-create-email-names');
                const addMoreEmailNameBtn = chosenForm.querySelector('.btn-create-add-email-names');


                chosenForm.addEventListener('input', (e) => {
                    e.preventDefault();
                    getValuesForCampaigns(chosenForm);
                });


                if ( chosenForm.matches('#addNewCampaignFormMedia') ) {
                    createBtn.addEventListener('click', (e) => {
                        e.preventDefault();
                        generateNames('#mediaStepOne', '#mediaStepTwo', chosenForm, 'Campaign Names Created!');
                    })
                    placementBtn.addEventListener('click', (e) => {
                        e.preventDefault();
                        generateCampaignItems('#mediaStepTwo', '#mediaStepThree', chosenForm, projectPlacementCreateEndpoint, 'Placements Created!');
                    });
                    placementAddBtn.addEventListener('click', (e) => {
                        e.preventDefault();
                        generateCampainItemAndClear('#mediaStepTwo', '', chosenForm, projectPlacementCreateEndpoint, 'Placements Created!');
                    });
                    creativeBtn.addEventListener('click', (e) => {
                        e.preventDefault();
                        if (document.body.matches('.media-creative-step') ){
                            document.body.classList.add('media-form-done');
                        }
                        generateCampaignItems('#mediaStepThree', '#mediaStepThree', chosenForm, projectCreativeCreateEndpoint, 'Creatives Created!');
                    });
                    creativeAddBtn.addEventListener('click', (e) => {
                        e.preventDefault();
                        generateCampainItemAndClear('#mediaStepThree', '', chosenForm, projectCreativeCreateEndpoint, 'Creatives Created!')
                    });
                }
                if ( chosenForm.matches('#addNewCampaignFormSearch')) {
                    createBtn.addEventListener('click', (e) => {
                        e.preventDefault();
                        generateNames('#searchStepOne', '#searchStepTwo', chosenForm, 'Campaign Names Created!');
                    });
                    searchBtn.addEventListener('click', (e) => {
                        e.preventDefault();
                        generateCampaignItems('#searchStepTwo', '#searchStepTwo', chosenForm, projectAdgroupCreateEndpoint, 'Ad Group Created!');
                    });
                    searchGroupBtn.addEventListener('click', (e) => {
                        e.preventDefault();
                        generateCampainItemAndClear('#searchStepTwo', '', chosenForm, projectAdgroupCreateEndpoint, 'Ad Group Created!');
                    });
                }

                if ( chosenForm.matches('#addNewCampaignFormEmail') ) {
                    createBtn.addEventListener('click', (e) => {
                        e.preventDefault();
                        generateNames('#emailStepOne', '#emailStepTwo', chosenForm, 'Campaign Names Created!');
                    });
                    emailNameBtn.addEventListener('click', (e) => {
                        e.preventDefault();
                        generateCampaignItems('#emailStepTwo', '#emailStepTwo', chosenForm, projectEmailEndpoint, 'Email Names Created!');
                    });
                    addMoreEmailNameBtn.addEventListener('click', (e) => {
                        e.preventDefault();
                        generateCampainItemAndClear('#emailStepTwo', '#emailStepTwo', chosenForm, projectEmailEndpoint, 'Email Names Created!')
                    });
                }
            });
        }
    }
};
